import isString from 'lodash/isString';

export const FILTER_TYPES = {
  DATE_RANGE: 'dateRange',
  RANGE: 'range',
  STARTS_WITH: 'startsWith',
  COMPOSITE: 'composite',
  ID_VALUE: 'idValue',
  LIST_SELECT: 'listSelect',
};

function makeDjangoUnderstandable(accessor) {
  return accessor.split('.').join('__');
}

function getColumn(columns, id) {
  return columns.find(c => c.id === id || c.accessor === id);
}

function getNumberValue(value) {
  return value.replace(/\D/g, '');
}

function transformFilters(rawFilters, columns) {
  const processedFilters = {};

  rawFilters.forEach(({ id, value }) => {
    const { accessor, filterCriteria, filterKey } = getColumn(columns, id);
    const key = filterKey || makeDjangoUnderstandable(accessor);

    if (!filterCriteria) {
      processedFilters[key] = isString(value) ? value.trim() : value;
    } else if (filterCriteria === FILTER_TYPES.ID_VALUE) {
      const idValue = getNumberValue(value);
      if (idValue) processedFilters[key] = idValue;
    } else if (filterCriteria === FILTER_TYPES.RANGE) {
      processedFilters[`${key}_min`] = value.min;
      processedFilters[`${key}_max`] = value.max;
    } else if (filterCriteria === FILTER_TYPES.LIST_SELECT) {
      processedFilters[key] = value.listIds;
    } else if (filterCriteria === FILTER_TYPES.DATE_RANGE) {
      processedFilters[`${key}_after`] = value.startDate;
      processedFilters[`${key}_before`] = value.endDate;
    } else if (filterCriteria === FILTER_TYPES.COMPOSITE) {
      const [key1, key2] = key.split('++');
      const [value1, value2] = value
        .split('(')
        .map(k => k.trim().replace(/\)/g, ''));
      processedFilters[key1] = value1;
      processedFilters[key2] = value2 || value1;
    } else {
      processedFilters[`${key}_${filterCriteria}`] = value;
    }
  });
  return processedFilters;
}

function transformSortParams(sorted, columns) {
  return sorted
    .map(({ id, desc }) => {
      const { accessor, sortKey } = getColumn(columns, id);
      const key = sortKey || makeDjangoUnderstandable(accessor);
      return `${!desc ? '-' : ''}${key}`;
    })
    .join(',');
}

export function transformTableStateToSearchParams(state, columns) {
  const { pageSize, page, sorted, filtered } = state;
  return {
    page: page + 1,
    pageSize,
    sort: transformSortParams(sorted, columns),
    filters: transformFilters(filtered, columns),
  };
}
